import React from "react";
import { Box, type BoxProps, type SpaceProps } from "@chakra-ui/react";
import { type Theme } from "contexts/color-theme";

type RuleProps = {
  theme?: Theme;
} & SpaceProps &
  Pick<BoxProps, "display" | "maxW">;

export function Rule({ theme = "light", ...props }: RuleProps) {
  return (
    <Box w="100%" py="small" {...props}>
      <Box as="hr" borderColor={`brand.border.${theme}`} />
    </Box>
  );
}
